import styled from 'styled-components';

export const Content = styled.div`
  padding: 15px;
  box-sizing: border-box;
  textarea {
    font-size: 14px;
    font-family: monospace, monospace;
    overflow: hidden;
    padding: 3px;
    border-radius: 3px;
    resize: none;
  }
  select {
    padding: 3px;
    border-radius: 3px;
  }
`;
export const Label = styled.label`
  color: #eee;
  display: block;
  margin: 0 0 7px;
`;
export const TypeSelector = styled.div`
  margin: 0 0 15px;
`;

export const Buttons = styled.div`
  justify-content: space-between;
  display: flex;
`;
export const Button = styled.button`
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #eee;
  border-radius: 16px;
  padding: 0 15px;
  border: 0;
  cursor: pointer;
  background: #38414b;
  margin: 0;
  position: relative;
`;
